'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import { type } from 'jquery';
import routes from './commercial_uses.routes';

export class CommercialUsesComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $http, baseConfigService, $location, $stateParams, $timeout) {
    const vm = this;
    this.$scope = $scope;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$state = $state;
    this.userService = userService;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$http = $http;
    $scope.savemode = null;
    $scope.densityType = 'Commercial';
    $scope.showTierException = false;
    $scope.updateData = [];
    $scope.initialLoad = true;
    $scope.density = {}


    $scope.adminUnlocked = false; // track admin manual unlock
    $scope.submitDensityForReview = false;
    $scope.pendingChanges = false;
    $scope.commercialUsesCheck = false;
    $scope.submitmode = null;
    $scope.attachmentData = $scope.attachmentData || {};
    $scope.submissions = [];
    $scope.baseUrl = baseConfigService.getBaseURL();
    $scope.policy_name = 'Commercial Office Uses Data Verification'

    $scope.showPanel = null;

    $scope.togglePanel = function (panelName) {
      $scope.showPanel = panelName;
    };
    
    $scope.scrollToTop = function() {
      window.scrollTo(0, 0);
    };

    $scope.commercial_density_no_changes_checked = false;
    $scope.commercial_density_table_changes_checked = false;

    $scope.setPending = function () {
      console.log('set pending ran')
      console.log($scope.initialLoad);
      if(!$scope.initialLoad){
        $scope.savemode = 'validation';
        $scope.pendingChanges = true;
      }
    }
    



    $scope.thresholds = [
      {
        'tier': '1',
        'threshold': {
          toc_min_dua: 100,
          toc_max_dua: 150,
          toc_min_far: 4,
          toc_max_far: 8
        }
      },
      {
        'tier': '2',
        'threshold': {
          toc_min_dua: 75,
          toc_max_dua: 100,
          toc_min_far: 3,
          toc_max_far: 6
        }
      },
      {
        'tier': '3',
        'threshold': {
          toc_min_dua: 50,
          toc_max_dua: 75,
          toc_min_far: 2,
          toc_max_far: 4
        }
      },
      {
        'tier': '4',
        'threshold': {
          toc_min_dua: 25,
          toc_max_dua: 35,
          toc_min_far: 1,
          toc_max_far: 3
        }
      }
    ]

            $scope.isFormEditable = function () {
      if (!$scope.currentDensityPolicy) return true;

      var role = $scope.currentUser && $scope.currentUser.role;
      // Find matching submission status for current policy
      var submission = null;
      if ($scope.stationStatus) {
        for (var i = 0; i < $scope.stationStatus.length; i++) {
          if ($scope.stationStatus[i].submission_policy_name === $scope.policy_name) {
            submission = $scope.stationStatus[i];
            break;
          }
        }
      }      
      // Not yet submitted — allow editing
      if (!submission || !submission.submitted) return true;

      // Admins can edit if they've manually unlocked
      if (role === 'Administrator') {
        return $scope.adminUnlocked;
      }
      // Admin set it to "Needs Work" — allow editing without withdraw
      if (submission.status === 'Needs Work') return true;

      return false;
    };

    $scope.$watch(
      function () {
        return $scope.currentDensityPolicy
      },
      function () {
        $scope.adminUnlocked = false;
        $scope.formReadOnly = !$scope.isFormEditable();
        $scope.withdrawnNotice = false;
        $scope.needsWorkNotice = false;
        if ($scope.stationStatus && $scope.policy_name) {
          var sub = _.find($scope.stationStatus, { submission_policy_name: $scope.policy_name });
          if (sub && sub.submitted && sub.status === 'Needs Work') { $scope.needsWorkNotice = true; }
        }
      }
    );

    $scope.$watch('stationStatus', function () {
      $scope.formReadOnly = !$scope.isFormEditable();
    }, true);

    $scope.toggleAdminUnlock = function () {
      $scope.adminUnlocked = !$scope.adminUnlocked;
      $scope.formReadOnly = !$scope.isFormEditable();
    };

    $scope.withdrawSubmission = function () {
      var confirmWithdraw = window.confirm(
        "Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.",
      );
      if (!confirmWithdraw) return;

      var submission = null;
      if ($scope.stationStatus) {
        for (var i = 0; i < $scope.stationStatus.length; i++) {
          if (
            $scope.stationStatus[i].submission_policy_name ===
            $scope.policy_name
          ) {
            submission = $scope.stationStatus[i];
            break;
          }
        }
      }

      if (!submission || !submission.submission_id) {
        console.error("No matching submission found to withdraw");
        return;
      }

      var payload = {
        submission_id: submission.submission_id,
        submitted: false,
        status: null,
      };

       fetch.updateItem('api/data/submissions/update-status', payload)
    .then(function () {
      submission.submitted = false;
      submission.status = null;

       if ($scope.policy_name === 'Residential Uses Data Verification') {
        $scope.residentialUsesCheck = false;
        $scope.density.residentialUsesCheck = false;
      } else if ($scope.policy_name === 'Commercial Office Uses Data Verification') {
        $scope.commercialUsesCheck = false;
        $scope.density.commercialUsesCheck = false;
      } else if ($scope.policy_name === 'Minimum FAR Office') {
        $scope.minFAR = false;
      } else if ($scope.policy_name === 'Maximum FAR Office') {
        $scope.maxFAR = false;
      }

      if (!$scope.minFAR && !$scope.maxFAR && !$scope.residentialUsesCheck && !$scope.commercialUsesCheck) {
        $scope.submitted = false;
      }

      $scope.submissions = $scope.submissions.filter(function (s) {
        return s.submission_id !== submission.submission_id;
      });

      if ($scope.submissions.length === 0) {
        $scope.submitmode = null;
      }

      // Clear form fields — preserve only identity fields
      var formId = $scope.currentDensityPolicy ? $scope.currentDensityPolicy.density_form_id : null;
      $scope.currentDensityPolicy = { density_form_id: formId };
      if ($scope.hot) { $scope.hot.loadData([]); }

      // Show withdrawn notification
      $scope.withdrawnNotice = true;
      $scope.needsWorkNotice = false;
      $scope.success = false;

      $scope.formReadOnly = false;
    })
    .catch(function (err) {
      console.error('Withdraw failed:', err);
      alert('There was an error withdrawing the submission. Please try again.');
    });
};

    $scope.onCommercialCheckboxChange = function(type) {
      if (type === 'noChanges' && $scope.currentDensityPolicy.commercial_density_no_changes_checked) {
        $scope.currentDensityPolicy.commercial_density_table_changes_checked = false;
      }
      if (type === 'tableChanges' && $scope.currentDensityPolicy.commercial_density_table_changes_checked) {
        $scope.currentDensityPolicy.commercial_density_no_changes_checked = false;
      }
    };

  $scope.addToSubmissions = function (submission) {
    const index = $scope.submissions.indexOf(submission);
    if (index > -1) { // only splice array when item is found
      $scope.submissions.splice(index, 1); // 2nd parameter means remove one item only
    } else {
      $scope.submissions.push(submission);
    
    }
    console.log($scope.submissions)
    if ($scope.submissions.length > 0) {
      $scope.submitmode = 'density';
    } else {
      $scope.submitmode = null;
      
    }
  }
    /**
     * Get list of zoning codes by jurisdiction
     * @param {*} jurisdiction 
     */
    $scope.getZoningCodes = function (jurisdiction) {
      $scope.loadingTable = true;
      $scope.currentJurisdiction = jurisdiction;
      lookup.setJurisdiction($scope.currentJurisdiction);
      fetch.getAllItems(`api/data/density/zoning/${jurisdiction}`)
        .then(response => {
          $scope.znCodes = response.data;
          $scope.loadingTable = false;
          $scope.initialLoad = false;
          $scope.znCodes.forEach(element => {

            element.last_edited = moment(element.last_edited).format('L');

            if (element.zn_code_url) {
              element.zn_code_url = `<a href='${element.zn_code_url}' target='_blank'>${element.zn_code_url}</a>`;
            }
          });
          $scope.znCodes = _.orderBy($scope.znCodes, 'allows_comm_office', 'desc');
          $scope.loadTable($scope.znCodes);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            this.$state.go('login');
          }
        })
    }

    /**
     * Load handsontable based on zoning data returned for jurisdiction
     * @param {*} data 
     */
    $scope.loadTable = function (data) {
      const container = document.querySelector('#handsOnTable');
      // original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      function strip_tags(input, allowed) {
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
          commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;

        // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
        allowed = (((allowed || "") + "").toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');

        return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
          return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
        });
      }

      function safeHtmlRenderer(instance, td, row, col, prop, value, cellProperties) {
        var escaped = Handsontable.helper.stringify(value);
        escaped = strip_tags(escaped, '<em><b><strong><a><big>'); //be sure you only allow certain HTML tags to avoid XSS threats (you should also remove unwanted HTML attributes)
        td.innerHTML = escaped;

        return td;
      }

      if (typeof $scope.hot !== 'undefined') {
        $scope.hot.loadData(data);
        $scope.hot.render();
      }
      else {

        $scope.hot = new Handsontable(container, {
          data,
          colHeaders: false, // Disable default column headers
          nestedHeaders: [
            [
              'ID',
              'Zoning ID',
              'Jurisdiction',
              'Zoning Code',
              'Description',
              'Allows <br> Office',
              "Min FAR",
              "Max FAR",
              "Calculated Using <br> Height",
              "Acres <br> Within Zone",
              "Acres of Existing <br> Commercial Office Excluded",
              "Documentation",
              "Last Edited",
              "Editor"

            ],
          ],
          allowInsertRow: true,
          manualColumnResize: true,
          height: 600,
          overflow: 'auto',
          colWidths: [null, null, null, 40, 150, 50, 30, 30, 60, 60, 180],
          stretchH: 'all',
          autoWrapRow: true,
          rowHeaders: true,
          filters: true,
          // contextMenu: true,
          dropdownMenu: [
            "filter_by_condition",
            "filter_by_value",
            "filter_action_bar",
          ],
          manualColumnMove: true, // enable moving columns
          manualColumnFreeze: true, // enable freezing columns
          manualColumnResize: true, // enable resizing columns
          multiColumnSorting: {
            indicator: true,
          },

          columns: [
            { data: 'rec_id' },
            { data: 'zn_recid' },
            {
              data: 'jurisdiction',
              type: 'text'
            },
            { data: 'zn_code' },
            { data: 'zn_description' },
            {
              data: 'allows_comm_office',
              type: "checkbox",
              className: "htCenter"
            },
            {
              data: 'toc_min_far',
              type: 'numeric'
            },
            {
              data: 'toc_max_far',
              type: 'numeric'
            },
            {
              data: 'use_height',
              type: 'checkbox',
              className: "htCenter"
            },
            {
              data: 'acres_within_zone',
              editor: false
            },
            {
              data: 'acres_excluded',
              editor: false
            },
            {
              data: 'zn_code_url',
              renderer: 'html'
            },
            {
              data: 'last_edited',
              type: 'date',
              dateFormat: 'MM/DD/YYYY',
              correctFormat: true,
              defaultDate: '01/01/1900',
              // datePicker additional options
              // (see https://github.com/dbushell/Pikaday#configuration)
              datePickerConfig: {
                // First day of the week (0: Sunday, 1: Monday, etc)
                firstDay: 0,
                showWeekNumber: true,
                disableDayFn(date) {
                  // Disable Sunday and Saturday
                  return date.getDay() === 0 || date.getDay() === 6;
                }
              }
            },
            {
              data: 'editor_id',
              editor: false
            },


          ],
          hiddenColumns: {
            // specify columns hidden by default
            columns: [0, 1, 2],
            indicators: true
          },
          minSpareRows: 1,
          licenseKey: 'non-commercial-and-evaluation',
          readOnly: !!$scope.formReadOnly,
          afterValidate(isValid, value, row, prop, source) {
            // console.log(isValid);
            // console.log(value);
            // console.log(row);
            // console.log(prop);
            // console.log(source);
            // thisIsValid = isValid;
          },
        });

        $scope.hot.addHook("afterChange", function (changes, source) {

          if (changes && source !== 'UndoRedo.undo') {
            changes.forEach(([row, prop, oldValue, newValue]) => {
              if (newValue === '') {
                newValue = null
              }
              var handsonUpdate = $scope.hot.getDataAtRow(row);
              $scope.updateData.push({
                rec_id: handsonUpdate[0],
                zn_recid: handsonUpdate[1],
                [prop]: newValue,
                [`${prop}_old`]: oldValue
              });
            });
            $scope.beforeSave()
          }

        });

      }
       $scope.$watch('formReadOnly', function (newVal) {
  if ($scope.hot) {
    $scope.hot.updateSettings({
      readOnly: !!newVal
    });
    $scope.hot.render();
  }
});
    }

    $scope.addToSubmissions = function (submission) {
      const index = $scope.submissions.indexOf(submission);
      if (index > -1) { // only splice array when item is found
        $scope.submissions.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        $scope.submissions.push(submission);
      
      }
      console.log($scope.submissions)
      if ($scope.submissions.length > 0) {
        $scope.submitmode = 'density';
      } else {
        $scope.submitmode = null;
        
      }
    }

    /**
     * Update station area dropdown based on jurisdiction selected
     * @param {*} jurisdiction 
     */
    $scope.getStationAreaList = function (jurisdiction) {
      // Check for the sta_recid parameter from $stateParams
      const staRecId = $stateParams.sta_recid;

      $scope.getZoningCodes(jurisdiction);
      fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
        .then(response => {
          $scope.stationAreas = response.data;

          // Set currentSelectedStationId based on sta_recid if it exists
          if (staRecId) {
            $scope.currentSelectedStationId = staRecId; // Set from URL parameter
          } else if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation(); // Fallback
          }

          // Call getStationbyID() after setting the currentSelectedStationId
          $scope.getStationbyID();
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    };


    $scope.getStationbyID = function () {
      $scope.pendingAverages = false;
      lookup.setCurrentStation($scope.currentSelectedStationId);
      $scope.loading = true;
      $scope.loadingTable = true;
      setTimeout(function () {
        fetch.getItem(`api/data/density/averages/${$scope.currentJurisdiction}`, $scope.currentSelectedStationId)
          .then(response => {
            $scope.currentStation = response.data[0];

            $scope.loading = false;
            $scope.getSubmissionStatus($scope.currentSelectedStationId);
            $scope.getZoningCodesByParcel($scope.currentSelectedStationId);

            // Call the overrideTierForSpecificCorridors function
            // $scope.overrideTierForSpecificCorridors($scope.currentStation);

            if ($scope.currentStation && $scope.currentStation.service_tier) {
              var tier = $scope.currentStation.service_tier.toString();
              $scope.complianceThresholds = (_.filter($scope.thresholds, { 'tier': tier }))[0].threshold;
            }

            vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
          
            return $scope.getCurrentDensityPolicy($scope.policy_name);
          }
          )
          .catch(err => {
            console.log(err);
            if (err.status === 403) {
              $state.go('login');
            }
          })
      }, 2000)
    }

    $scope.getCurrentDensityPolicy = function (policy_name) {

      if (policy_name) {
      $scope.policy_name = policy_name;
    }
    console.log('policy_name:', policy_name);

    fetch.getAllItems(`api/data/getDensityForm/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}/${encodeURIComponent($scope.policy_name)}`)
      .then(response => {
        
        if (response.data && response.data.length > 0) {
          $scope.currentDensityPolicy = response.data[0];
        
        console.log('density_form_id:', $scope.currentDensityPolicy.density_form_id);
        if(policy_name === 'Residential Uses Data Verification'){
          if($scope.residential_density_no_changes_checked){
            $scope.residential_density_no_changes_checked = true;
          }
          if($scope.residential_density_table_changes_checked){
            $scope.residential_density_table_changes_checked = true;
          }
          if($scope.currentDensityPolicy.residential_density_equivalency_table){
            $scope.residential_density_equivalency_table_checked = true;
          }
          if($scope.currentDensityPolicy.residential_density_equivalency_table){
            $scope.residential_density_equivalency_table_checked = true;
          }
          if($scope.currentDensityPolicy.residential_density_exclude_parcels){
            $scope.residential_density_exclude_parcels_checked = true;
          }
          if($scope.currentDensityPolicy.residential_density_adopted_plan){
            $scope.residential_density_adopted_plan_checked = true;
          }
          if($scope.currentDensityPolicy.residential_exclude_parcels_additional_details){
            $scope.residential_density_exclude_parcels_checked = true;
          }
          if($scope.currentDensityPolicy.residential_equivalency_table_additional_details){
            $scope.residential_density_equivalency_table_checked = true;
          }
          if($scope.currentDensityPolicy.residential_adopted_plan_additional_details){
            $scope.residential_density_adopted_plan_checked = true;
          }  
        }
          if(policy_name === 'Commercial Office Uses Data Verification'){
            if($scope.currentDensityPolicy.commercial_density_equivalency_table){
              $scope.commercial_density_equivalency_table_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_density_adopted_plan){
              $scope.commercial_density_adopted_plan_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_density_exclude_parcels){
              $scope.commercial_density_exclude_parcels_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_exclude_parcels_additional_details){
              $scope.commercial_density_exclude_parcels_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_equivalency_table_additional_details){
              $scope.commercial_density_equivalency_table_checked = true;
            }
            if($scope.currentDensityPolicy.commercial_adopted_plan_additional_details){
              $scope.commercial_density_adopted_plan_checked = true;
            }
        }
        $scope.initialLoad = false;
        console.log($scope.initialLoad);
      }
    })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })

  }

    $scope.updateCurrentDensityPolicy = function () {

      $scope.formSubmitted = true;
      if (densityForm.$invalid) {
        $scope.saving = false;
        return;
      }

        // Ensure cleared fields send `null` instead of empty strings or undefined values
        Object.keys($scope.currentDensityPolicy).forEach(key => {
          if ($scope.currentDensityPolicy[key] === "" || $scope.currentDensityPolicy[key] === undefined) {
            $scope.currentDensityPolicy[key] = null;
          }
        });

      console.log("Payload being sent:", $scope.currentDensityPolicy);
      fetch.updateItem(`api/data/density/forms/update`, $scope.currentDensityPolicy)
      .then(response => {
        
        $scope.saved = true;
        $scope.saving = false;
        $scope.pendingChanges = false;
        setTimeout(() => {
          // $scope.submitmode = null;
          $scope.saved = false;
          $scope.savemode = null;
          $scope.$apply();
        }, 4000);
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })
    }

    $scope.getSubmissionStatus = function (stationId) {
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${stationId}`, 'Density')
        .then(response => {
          $scope.stationStatus = response.data;
          
          const minFARResult = _.filter($scope.stationStatus, { submission_policy_name: 'Minimum FAR Office' });
          $scope.minFAR = minFARResult.length > 0 ? minFARResult[0].submitted : false;

          const maxFARResult = _.filter($scope.stationStatus, { submission_policy_name: 'Maximum FAR Office' });
          $scope.maxFAR = maxFARResult.length > 0 ? maxFARResult[0].submitted : false;

          // Check for Commercial Uses
          const commercialUses = _.filter($scope.stationStatus, { submission_policy_name: 'Commercial Office Uses Data Verification' });
          if (commercialUses.length > 0) {
            commercialUses.forEach(element => {
              if (element.submitted === true) {
                $scope.commercialUsesCheck = true;
              }
            });
          }
          
          // If any check is true, set $scope.submitted to true
          if ($scope.minFAR || $scope.maxFAR || $scope.commercialUsesCheck) {
            $scope.submitted = true;
          }
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }


    $scope.getZoningCodesByParcel = function (station) {
      fetch.getAllItems(`api/data/density/zoningcodes/${$scope.densityType}/${$scope.currentJurisdiction}/${encodeURIComponent(station)}`, $scope.znCodes)
        .then(response => {

          // Update zoning codes with lot area sizes
          $scope.znCodes.forEach(element => {
            var znCodeAreaInclude = _.filter(response.data, { zn_code: element.zn_code, exclude: false })[0];
            if (znCodeAreaInclude && znCodeAreaInclude.total_gisacre) {
              element.acres_within_zone = parseFloat(znCodeAreaInclude.total_gisacre).toFixed(2);
            }

            var znCodeAreaExclude = _.filter(response.data, { zn_code: element.zn_code, exclude: true })[0];
            if (znCodeAreaExclude && znCodeAreaExclude.total_gisacre) {
              element.acres_excluded = parseFloat(znCodeAreaExclude.total_gisacre).toFixed(2);
            }
          });

          // Identify highlighted zn_codes
          var highlightedZnCodes = new Set(response.data.map(item => item.zn_code));

          // Separate highlighted and non-highlighted rows
          const highlightedRows = [];
          const nonHighlightedRows = [];

          $scope.znCodes.forEach(row => {
            if (highlightedZnCodes.has(row.zn_code)) {
              highlightedRows.push(row);
            } else {
              nonHighlightedRows.push(row);
            }
          });

          // Combine highlighted rows and non-highlighted rows
          const sortedZnCodes = highlightedRows.concat(nonHighlightedRows);

          // Update handsontable with sorted data
          $scope.hot.updateSettings({
            data: sortedZnCodes, // Update with the sorted data
            cells: function (row, col) {
              var cellProperties = {};
              var znCode = $scope.hot.getDataAtCell(row, 3); // Assuming zn_code is in column index 3

              if (highlightedZnCodes.has(znCode)) {
                if (col === 5 || col === 8) {
                  cellProperties.className = 'highlightRow htCenter';
                } else {
                  cellProperties.className = 'highlightRow';
                }
              }

              return cellProperties;
            }
          });

          $scope.loadingTable = false;
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    }


  // File upload functions 

$scope.initializeField = function (fieldId) {
  if (!$scope.attachmentData[fieldId]) {
    $scope.attachmentData[fieldId] = {
      fileName: null,
      file: null,
      isFileSelected: false
    };
  }
};

// Function to open the file dialog
$scope.openFileDialog = function (fieldId) {
  $timeout(function () {
    document.getElementById('fileInput' + fieldId).click();
  }, 0);
};

// Function to handle file changes
$scope.fileChanged = function (fieldId, element) {
  $scope.initializeField(fieldId);  // Ensure field is initialized

  var file = element.files[0];
  if (file) {
    // Check if the file type is PDF, Word document, or Excel file
    if (
      file.type !== 'application/pdf' &&
      file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && // For .docx
      file.type !== 'application/msword' && // For .doc
      file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && // For .xlsx
      file.type !== 'application/vnd.ms-excel' // For .xls
    ) {
      alert('Please select a PDF, Word document, or Excel file.');
      element.value = ''; // Reset input to clear the wrong file type
      return;
    }

    $scope.attachmentData[fieldId].fileName = file.name;
    $scope.attachmentData[fieldId].file = file;
    $scope.attachmentData[fieldId].isFileSelected = true;

    $scope.$apply();
  }
};

$scope.clearFile = function(ngmodel) {
    console.log(ngmodel);
    var fileInput = document.getElementById(`${ngmodel}`);
    console.log(fileInput);
    if (fileInput) {
        fileInput.value = ''; // clears the file input
        // Clear any associated model/preview values
        $scope[ngmodel] = '';
        $scope[`${ngmodel}_preview`] = '';
        $scope[`fileUploading_${ngmodel}`] = false;
        
        // If there's a form control, reset its validation state
        if ($scope.form && $scope.form[ngmodel]) {
            $scope.form[ngmodel].$setPristine();
            $scope.form[ngmodel].$setUntouched();
        }
    }
};

$scope.uploadFile = function(ngmodelfile) {
  var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
  console.log(ngmodel);
  $scope[`fileUploading_${ngmodelfile}`] = true;
  var file = document.getElementById(`${ngmodelfile}`).files[0];

  if (!file) {
    console.error('No file selected');
    return;
  }

  var fileUpload = {
    fileName: file.name,
    fileType: file.type
  };

  // Using POST to get the signed URL and public URL
  fetch.updateItem('api/data/get-signed-url', fileUpload)
    .then(response => {
      console.log('Signed URL:', response.data.signedUrl);
      console.log('Public URL:', response.data.publicUrl);

      // Use the signed URL to upload the file
      return $http({
        method: 'PUT',
        url: response.data.signedUrl,
        data: file,
        headers: {
          'Content-Type': file.type,
          // 'x-amz-acl': 'public-read' // Ensure the file is publicly readable
        }
      })
      .then(() => {
        // After successful upload, store the public URL in the scope
        $scope.currentDensityPolicy[ngmodel] = response.data.publicUrl;
        return response.data.publicUrl; // Return the public URL for further use
      });
    })
    .then(publicUrl => {
      console.log('Upload successful');
      console.log('Public URL:', publicUrl);

      // Update UI state
      $scope[`fileUploading_${ngmodelfile}`] = false;
      $scope[`${ngmodelfile}`] = '';
      $scope.clearFile(ngmodelfile);
      $scope.uploadSuccess = true;
    })
    .catch(error => {
      console.error('Error:', error);
      alert('Upload failed');
    });
};

$scope.checkSubstring = function (input) {
return input && input.length >= 4 && input.substring(0, 4) === 'http';
};

$scope.removeFile = function(ngmodel) {
console.log(ngmodel);
  $scope.currentDensityPolicy[ngmodel] = '';
  $scope.setPending();
  $scope.savemode = 'validation';
  $scope.pendingChanges = true;
};


// End file upload functions 
    /**
* Function to save validation information for residential zoning
* Variable definitions
* saving (true/false)           : Flag to show saving messages and icons e.g., fa-cog spin
* saved (true/false)            : Flag showing saved messages and icons
* saveType                      : Text showing on save button
* currentStation                : Currently selected station area
* Fn getStationbyId             : Function retrieving weighted averages for density
* setTimeout                    : Function for how long saved messages show. Set to 3 seconds
*/
  //   $scope.saveValidation = function () {
  //     $scope.saving = true;
  //     $scope.upsertData = _.filter($scope.stationStatus, function (o) {
  //       if (o.policy === 'Minimum FAR Office' || o.policy === 'Maximum FAR Office') {
  //         return o
  //       }
  //     });

  //       // create the uniqueKey for localStorage
  // const uniqueKey = `commercialUsesData_${$scope.currentJurisdiction}_${$scope.currentSelectedStationId}`;

  // console.log(uniqueKey)
  //      // Save the data to localStorage
  // const savedData = {
  //   density_no_changes_check: $scope.density_no_changes_check,
  //   density_table_changes_check: $scope.density_table_changes_check,
  //   density_equivalency_table_check: $scope.density_equivalency_table_check,
  //   density_adopted_plan_check: $scope.density_adopted_plan_check,
  //   density_exclude_parcels_check: $scope.density_exclude_parcels_check,
  //   density_revising_information_check: $scope.density_revising_information_check,
  //   density_adopted_plan_additional_details: $scope.density_adopted_plan_additional_details,
  //   density_equivalency_table_additional_details: $scope.density_equivalency_table_additional_details,
  //   density_revising_information_additional_details: $scope.density_revising_information_additional_details,
  //   // Restore file upload URLs
  //   density_equivalency_table: $scope.density_equivalency_table,
  //   density_adopted_plan: $scope.density_adopted_plan,
  //   density_exclude_parcels: $scope.density_exclude_parcels,

  //   upsertData: $scope.upsertData
  // };

  // console.log('Data to be saved:', savedData);
  // console.log('Data to be saved:', {
  //   density_equivalency_table: $scope.density_equivalency_table,
  //   density_adopted_plan: $scope.density_adopted_plan,
  //   density_exclude_parcels: $scope.density_exclude_parcels
  // });
  // localStorage.setItem(uniqueKey, JSON.stringify(savedData));

  //     if ($scope.density_no_changes_check) {
  //       $scope.upsertData.forEach(element => {
  //         element.density_no_changes = true;
  //       });
  //     }
  //     if ($scope.density_table_changes_check) {
  //       $scope.upsertData.forEach(element => {
  //         element.density_table_changes = true;
  //       });
  //     }

  //     if ($scope.density_equivalency_table_check) {
  //       $scope.upsertData.forEach(element => {
  //         element.density_equivalency_table = $scope.density_equivalency_table;
  //       });
  //     }

  //     if ($scope.density_adopted_plan_check) {
  //       $scope.upsertData.forEach(element => {
  //         element.density_adopted_plan = $scope.density_adopted_plan;
  //       });
  //     }

  //     if ($scope.density_excluded_parcels_check) {
  //       $scope.upsertData.forEach(element => {
  //         element.density_excluded_parcels = $scope.density_excluded_parcels;
  //       });
  //     }

  //     if ($scope.density_adopted_plan_additional_details) {
  //       $scope.upsertData.forEach(element => {
  //         element.density_adopted_plan_additional_details = $scope.density_adopted_plan_additional_details;
  //       });
  //     }

  //     if ($scope.density_equivalency_table_additional_details) {
  //       $scope.upsertData.forEach(element => {
  //         element.density_equivalency_table_additional_details = $scope.density_equivalency_table_additional_details;
  //       });
  //     }

  //     if ($scope.density_excluded_parcels_additional_details) {
  //       $scope.upsertData.forEach(element => {
  //         element.density_excluded_parcels_additional_details = $scope.density_excluded_parcels_additional_details;
  //       });
  //     }



  //     fetch.updateItem(`api/data/submissions/update`, $scope.upsertData)
  //       .then(response => {

  //         $scope.saved = true;
  //         $scope.saving = false;
  //         $scope.success = true;
  //         $scope.getStationbyID();
  //         setTimeout(() => {
  //           $scope.success = false;
  //           $scope.savemode = null;
  //           $scope.saved = false;
  //           $scope.successMessage = null;
  //           $scope.$apply();
  //         }, 10000);
  //       })
  //       .catch(err => {
  //         console.log(err);
  //         if (err.status === 403) {
  //           $state.go('login');
  //         }
  //       })
  //   }

  //   $scope.checkValidation = function () {
  //     $scope.savemode = 'validation';
  //   }



    $scope.deleteZoningCodes = function () {
      $scope.saving = true;
      // iterate through znCodes and if selected add to updateData 
      $scope.updateData = [];
      $scope.znCodes.forEach(element => {
        if (element.selected) {
          $scope.updateData.push(element);
        }
      });
      $scope.saving = true;
      fetch.updateItem(`api/data/density/zoning/delete`, $scope.updateData)
        .then(response => {

          $scope.znCodes = _.filter($scope.znCodes, function (o) {
            return !o.selected
          })
          $scope.saving = false;
          $scope.updateData = [];
          $scope.hot.loadData($scope.znCodes);
          $('#deleteZoningCodeModal').modal('toggle');
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.addZoningCode = function () {
      $scope.saving = true;
      $scope.addCode.rec_id = lookup.getUUID();
      if ($scope.jurisdictionDetail) {
        $scope.addCode.jurisdiction_id = $scope.jurisdictionDetail.jurisdiction_id;
        $scope.addCode.county_id = $scope.jurisdictionDetail.county_id;
      }

      $scope.addCode.zn_recid = `${$scope.currentJurisdiction}-${$scope.addCode.zn_code}`;
      // Update allows residential and allows commercial to be 1/0 if true/false 

      // Set TOC values to be the same as zn min/max values 
      if ($scope.addCode.zn_min_dua) {
        $scope.addCode.toc_min_dua = $scope.addCode.zn_min_dua;
      } else {
        $scope.addCode.toc_min_dua = null;
        $scope.addCode.zn_min_dua = null;
      }
      if ($scope.addCode.zn_max_dua) {
        $scope.addCode.toc_max_dua = $scope.addCode.zn_max_dua;
      } else {
        $scope.addCode.toc_max_dua = null;
        $scope.addCode.zn_max_dua = null;
      }
      if ($scope.addCode.zn_min_far) {
        $scope.addCode.toc_min_far = $scope.addCode.zn_min_far;
      } else {
        $scope.addCode.toc_min_far = null;
        $scope.addCode.zn_min_far = null;
      }
      if ($scope.addCode.zn_max_far) {
        $scope.addCode.toc_max_far = $scope.addCode.zn_max_far;
      } else {
        $scope.addCode.toc_max_far = null;
        $scope.addCode.zn_max_far = null;
      }
      if (!$scope.addCode.allows_residential) {
        $scope.addCode.allows_residential = null;
      }
      if (!$scope.addCode.allows_residential) {
        $scope.addCode.allows_residential = null;
      }
      if (!$scope.addCode.allows_comm_office) {
        $scope.addCode.allows_comm_office = null;
      }
      if (!$scope.addCode.zn_code_url) {
        $scope.addCode.zn_code_url = null;
      }




      fetch.createItem(`api/data/density/zoning/create`, $scope.addCode)
        .then(response => {
          $scope.saved = true;
          $scope.saving = false;
          $scope.success = true;
          // Find the correct index to insert the new zoning code alphabetically
          const index = $scope.znCodes.findIndex(code => code.zn_code > $scope.addCode.zn_code);

          // Insert the new code at the correct index, or at the end if no index is found
          if (index > -1) {
            $scope.znCodes.splice(index, 0, $scope.addCode);
          } else {
            $scope.znCodes.push($scope.addCode);
          }

          $scope.hot.loadData($scope.znCodes);
          // $scope.getZoningCodes($scope.currentJurisdiction);
          $scope.addCode = {};

          $scope.notificationMessage = ''; // Clear any previous notification

          $('#addZoningCodeModal').modal('toggle');
        })
        .catch(error => {
          console.log(error);
          if (error.status === 403) {
            $state.go('login');
          }
          if (error.data && error.data.message && error.data.message.includes("duplicate key value violates unique constraint")) {
            console.log("This zoning code already exists");
            $scope.notificationMessage = `The zoning code ${$scope.addCode.zn_code} already exists in the table!`;
          } else {
            console.log("An error occurred:", error);
            $scope.notificationMessage = "An error occurred: " + (error.data && error.data.message ? error.data.message : 'Unknown error');
          }
          $scope.saving = false;
          $scope.addCode = {};

          // Clear the notification after 5 seconds
          $timeout(function () {
            $scope.notificationMessage = '';
          }, 5000); // 5000ms = 5 seconds

        })
    }
    // Export to CSV 
    $scope.exportToCSV = function () {
      // Get the data from the Handsontable instance
      const data = $scope.hot.getData();

      // Create a CSV string using a simple loop
      let csv = '';
      const headers = ['ID', 'Zoning ID', 'Jurisdiction', 'Zoning Code', 'Description', 'Allows Commercial Office', 'Min FAR', 'Max FAR', 'Calculated Using Height', 'Acres Within Zone', 'Acres of Existing Commercial Office Excluded', 'Documentation', 'Last Edited', 'Editor'];

      // Add header row
      csv += headers.join(',') + '\n';

      // Add data rows
      data.forEach(row => {
        csv += row.join(',') + '\n';
      });

      // Prompt the user for a filename
      const filename = prompt("Enter a filename for the CSV file:", "zoning_data.csv");

      // If the user cancels, do nothing
      if (filename === null) {
        return;
      }

      // Create a hidden link element
      const link = document.createElement('a');
      link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      link.download = filename;

      // Trigger a click event on the link to download the CSV file
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    // Get details for jurisdiction
    $scope.getJurisdictionDetail = function () {
      if ($scope.currentJurisdiction) {
        fetch.getItem(`api/data/jurisdiction/detail`, encodeURIComponent($scope.currentJurisdiction))
          .then(response => {
            $scope.jurisdictionDetail = response.data[0];
          })
          .catch(err => {
            console.log(err);
            if (err.status === 403) {
              $state.go('login');
            }
          })
      }
    }


  }
  $onInit() {
    // this.$scope.loading = true;
    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        // this.$scope.submitResidential = false;
        this.getJurisdictionList();
      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })

  }

  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
          if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }
        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
        this.$scope.getZoningCodes(this.$scope.currentJurisdiction);
      })
      .catch(err => {
        console.log(err);
      });
  }

  getStationAreaSubmissionSummary(stationId) {
    console.log('Getting summary for station:', stationId);
    this.lookup.setCurrentStation(stationId);

    if (this.$scope.stationAreas.length > 0) {
      this.$scope.stationAreas.forEach(element => {
        element.active = element.sta_recid === stationId;
        if (element.active) {
          this.$scope.stationAreaTitle = element.station_name;
        }
      });

      return this.fetch.getItem(
        `api/data/policies/${this.$scope.currentJurisdiction}`,
        stationId
      )
        .then(response => {
          console.log('Policy data:', response);
           this.$scope.submissionSummary = response.data;
          console.log("submission summary: ", this.$scope.submissionSummary);
          this.lookup.setSubmissionPolicies(this.$scope.submissionSummary);

          // Process density submissions
          this.$scope.densitySubmissions = _.filter(response.data,
            { submission_policy_type: "Density" });
          this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
            { submitted: true });
          this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
            { status: 'Compliant' });

          // Process housing policy submissions
          this.$scope.housingPolicySubmissions = _.filter(response.data,
            { submission_policy_type: "Housing Production Policy" });
          this.$scope.housingPolicySubmissions = _.union(
            this.$scope.housingPolicySubmissions,
            _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
          );
          this.$scope.housingPolicySubmitted = _.filter(
            this.$scope.housingPolicySubmissions,
            { submitted: true }
          );
          this.$scope.housingPolicyCompliant = _.filter(
            this.$scope.housingPolicySubmissions,
            { status: 'Compliant' }
          );

          // Process parking submissions
          this.$scope.parkingSubmissions = _.filter(response.data,
            { submission_policy_type: "Parking" });
          this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
            { submitted: true });
          this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
            { status: 'Compliant' });

          // Process station access submissions
          this.$scope.stationAccessSubmissions = _.filter(response.data,
            { submission_policy_type: "Station Area Access" });
          this.$scope.stationAccessSubmitted = _.filter(
            this.$scope.stationAccessSubmissions,
            { submitted: true }
          );
          this.$scope.stationAccessCompliant = _.filter(
            this.$scope.stationAccessSubmissions,
            { status: 'Compliant' }
          );
        });

      this.$scope.loading = false;
    } else {
      this.$scope.stationAreaTitle = '--';
      return Promise.resolve();
    }
  }


}

export default angular.module('appApp.commercial_uses', [uiRouter])
  .config(routes)
  .component('commercialUses', {
    template: require('./commercial_uses.html'),
    controller: CommercialUsesComponent,
    controllerAs: 'commercialUsesCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/density/commercial_uses/commercial_uses.component.js